import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconTwitter(props: IconProps & { invert?: boolean }) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        d="M22.228 0H1.773C.793 0 0 .77 0 1.72v20.56C0 23.23.794 24 1.773 24h20.455c.979 0 1.772-.77 1.772-1.72V1.72C24 .77 23.207 0 22.228 0Zm-2.723 6.95a4.122 4.122 0 0 0 1.771-2.284c-.779.473-1.64.817-2.56 1.001a3.973 3.973 0 0 0-2.94-1.303c-2.223 0-4.027 1.85-4.027 4.13 0 .324.035.639.104.941-3.348-.172-6.316-1.815-8.304-4.317a4.206 4.206 0 0 0-.545 2.079c0 1.432.71 2.697 1.792 3.438a3.955 3.955 0 0 1-1.826-.515v.05c0 2.003 1.389 3.673 3.233 4.05a3.842 3.842 0 0 1-1.061.146 3.91 3.91 0 0 1-.759-.073c.513 1.64 2 2.835 3.763 2.867a7.954 7.954 0 0 1-5.964 1.713 11.217 11.217 0 0 0 6.175 1.854c7.411 0 11.463-6.293 11.463-11.753 0-.18-.004-.359-.01-.535A8.268 8.268 0 0 0 21.817 6.3a7.87 7.87 0 0 1-2.313.65Z"
        fill={props.invert ? '#FFF' : '#00AAEC'}
      />
    </BaseIcon>
  );
}
